<template>
  <v-container>
    <!-- Hero -->
    <v-row justify="center" class="mt-4 mb-6">
      <v-col cols="12" class="text-center">
        <img src="@/assets/icons/logo_horizontal2.webp" alt="Amon Sûl" height="80" class="mb-4" />
        <h1 class="text-h4 font-weight-bold">Bienvenido a Amon Sûl</h1>
        <p class="text-subtitle-1 mt-2">
          La plataforma de gestión de eventos del wargame Middle-earth Strategy Battle Game.
          Organiza eventos, consulta estadísticas de tus partidas, el ranking ELO y sigue la competición en tiempo real.
        </p>
      </v-col>
    </v-row>

    <!-- Novedades -->
    <v-row class="mt-8 mb-2" justify="center">
      <v-col cols="12" class="text-center">
        <h2 class="text-h5 font-weight-bold mb-4">Últimas novedades</h2>
      </v-col>
      <v-col cols="12" md="10" lg="8">
        <!-- Compacta: la fecha va dentro de la tarjeta y el texto usa todo el ancho, también en móvil -->
        <v-timeline align="start" side="end" density="compact" truncate-line="start">
          <v-timeline-item
            v-for="novedad in novedades"
            :key="novedad.titulo"
            dot-color="primary"
            size="small"
          >
            <v-card class="pa-3" elevation="2">
              <span class="text-caption font-weight-bold text-primary">{{ novedad.fecha }}</span>
              <h3 class="text-h6 novedad-titulo">{{ novedad.titulo }}</h3>
              <!-- Justificado; con el idioma, el navegador parte palabras y no quedan huecos grandes en móvil -->
              <p class="text-body-2 novedad-texto" lang="es">{{ novedad.descripcion }}</p>
            </v-card>
          </v-timeline-item>
        </v-timeline>
      </v-col>
    </v-row>

    <!-- Características -->
    <v-row>
      <v-col cols="12" class="text-center">
        <h2 class="text-h5 font-weight-bold mb-4">¿Qué puedes hacer?</h2>
      </v-col>
      <v-col v-for="feature in features" :key="feature.title" cols="12" sm="6" md="4">
        <v-card class="text-center pa-4" elevation="3" height="100%">
          <img :src="feature.icon" :alt="feature.title" width="72" height="72" class="mb-3" />
          <h3 class="text-h6 mb-2">{{ feature.title }}</h3>
          <p class="text-body-2">{{ feature.description }}</p>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import gestionTorneos from "@/assets/icons/gestionTorneos.png";
import ELO from "@/assets/icons/ELO.png";
import clasificacion from "@/assets/icons/clasificacion.png";
import misPartidas from "@/assets/icons/misPartidas.png";
import usuarios from "@/assets/icons/usuarios.png";

export default {
  data() {
    return {
      novedades: [
        {
          fecha: "Noviembre 2026",
          titulo: "Estadísticas de ejércitos renovadas",
          descripcion:
            "Las estadísticas de ejércitos cambian por completo. En Ejércitos tienes el ranking de todos, con su % de victorias y su «Rinde», que dice si un ejército gana más o menos de lo que esperaba el ELO de quien lo lleva: así se separa lo que es del ejército de lo que es del jugador. Pulsa uno y verás cómo le va según los puntos y la temporada, contra qué ejércitos le va bien o mal y quién lo lleva mejor. En Cruces eliges dos ejércitos, o uno contra todo el Bien o todo el Mal, y ves cómo han quedado y sus partidas; si no eliges nada, salen los cruces más jugados y los más desequilibrados. En Jugadores ves con qué ejércitos juega cada uno, con cuál le va mejor o peor que de costumbre y contra cuáles sufre; desde la ficha de cualquier jugador se llega con «Sus estadísticas por ejército». Todo se filtra por temporada, por puntos y con o sin amistosas, y en «¿Cómo se calcula?» tienes los detalles.",
        },
        {
          fecha: "Noviembre 2026",
          titulo: "Nueva puntuación en los circuitos",
          descripcion:
            "Cambia cómo se puntúa en los circuitos, también en los de años anteriores. Ahora puntúa todo el que juega, aunque sea con 1 punto. Ganar vale más cuanto más grande es el evento: 35 puntos en uno de 8 jugadores, 45 en uno de 16, 55 en uno de 32 y 65 en uno de 64 o más; a partir de ahí ya no sube, para que un Nacional no decida el circuito él solo. Por debajo, lo que cuenta es quedar arriba: los puntos bajan rápido y a mitad de tabla te llevas más o menos la cuarta parte que el ganador. El podio suma 5, 3 y 1 puntos más, solo cuentan tus 4 mejores resultados y, si hay empate, va delante quien ha ganado más eventos. Además, los torneos terminados guardan solos su clasificación a final de mes, así que ya cuentan eventos que antes se quedaban fuera. En Circuitos verás los puntos de los 4 mejores resultados de cada jugador, en oro, plata o bronce si fue podio, y al pulsarlos, la clasificación de ese evento.",
        },
        {
          fecha: "Octubre 2026",
          titulo: "Mis partidas pasa a tu ficha de jugador",
          descripcion:
            "En el menú, Mis partidas se convierte en Ficha de jugador: tu propia ficha, con todas tus partidas y estadísticas. En la pestaña Amistosas registras una partida nueva y validas o cancelas las pendientes. Además, en el resumen puedes tocar un ejército o un rival para ver esas partidas, y la racha de arriba son tus últimas partidas de eventos: pulsando una se abre entera.",
        },
        {
          fecha: "Octubre 2026",
          titulo: "Nueva ficha de jugador",
          descripcion:
            "La ficha de cada jugador se ha rediseñado. Arriba, siempre a la vista, su ELO, su puesto en la clasificación y la racha de sus cinco últimas partidas. La pestaña Resumen junta la evolución del ELO, el balance de victorias, empates y derrotas en eventos y en amistosas, sus ejércitos más jugados, sus mejores resultados y, si miras la ficha de otro jugador, cómo os ha ido el uno contra el otro. Amistosas y Eventos tienen filtros por resultado y formato y un buscador de rival o evento, y en Resultados cada evento muestra la posición sobre el total de jugadores, como 3/45. Ah, y quien no tiene foto lleva ahora un Señor Oscuro muy poco temible.",
        },
        {
          fecha: "Octubre 2026",
          titulo: "Perfil renovado y avisos por correo",
          descripcion:
            "Tu perfil queda para tus datos: los personales, los de jugador y los de tu cuenta, con un formulario de edición más cómodo en el móvil; la foto se reduce sola al subirla. El ELO y las partidas están en tu ficha de jugador, con un botón para ir a ella. Además, ahora puedes desactivar los avisos por correo de nuevos eventos, rondas, inscripciones, pagos, listas y partidas amistosas. El correo para recuperar la contraseña te llegará siempre.",
        },
        {
          fecha: "Octubre 2026",
          titulo: "Rondas con nombre y eventos más claros",
          descripcion:
            "En Partidas de hoy y en el historial, las partidas de la eliminatoria de una copa aparecen con el nombre de su ronda: octavos de final, cuartos de final, semifinales o final. Mis torneos pasa a llamarse Mis eventos, y al crear o modificar un evento cada tipo de clasificación explica cómo se puntúa.",
        },
        {
          fecha: "Octubre 2026",
          titulo: "Llegan las Copas",
          descripcion:
            "Nuevo formato de evento: fase de grupos y eliminatoria, como un mundial. Al crear un evento, elige Copa y decide cuántos grupos hay, cuántos pasan de cada uno, cómo se reparten los jugadores (por ELO con bombos, al azar o a mano), quién pasa si un cruce de la eliminatoria acaba en empate y si hay partido por el tercer puesto. En cada grupo se juega todos contra todos con calendario abierto, como en la liga, y cada jugador lleva su ejército toda la copa. Al cerrar los grupos se monta el cuadro con los mejores, que avanza solo según se validan los cruces. Si la copa cuenta para el ELO, cada partida suma en cuanto la validan los dos jugadores.",
        },
        {
          fecha: "Octubre 2026",
          titulo: "Rondas más fáciles de seguir",
          descripcion:
            "En los torneos, cada ronda ya no es una pestaña: hay una sola pestaña Rondas con pastillas para pasar de una a otra, como las jornadas de la liga, tanto en la vista de los jugadores como en la gestión. Además, un buscador enseña solo las partidas de un jugador en cada ronda, con su mesa; en los torneos por equipos, también el cruce de su equipo.",
        },
        {
          fecha: "Octubre 2026",
          titulo: "Gestión de eventos renovada",
          descripcion:
            "La gestión pasa a llamarse Gestión Eventos. Las partidas de la gestión de torneos usan la misma tarjeta que las ligas y las copas: resultado, si cada jugador mató al general, quién la ha validado, escenario y fecha, y un botón para validarla de un toque. En los torneos por equipos, la gestión muestra también la clasificación individual, y en todos los torneos la clasificación individual ya detecta siempre el ejército y el bando de cada jugador.",
        },
        {
          fecha: "Octubre 2026",
          titulo: "Llegan las Ligas",
          descripcion:
            "Nuevo formato de evento: todos contra todos por jornadas. Al crear un evento, elige Liga como tipo y decide si es solo ida o ida y vuelta y si cuenta para el ELO. Cada jugador elige su ejército al inscribirse y lo lleva toda la liga, pero puede cambiar de lista antes de cada partida: cada partida guarda la lista con la que se jugó. Las jornadas se generan todas a la vez y el calendario es abierto: quedáis con vuestro rival y metéis el resultado en Mis partidas, dentro de la liga. Si la liga cuenta para el ELO, cada partida suma en cuanto la validan los dos jugadores.",
        },
        {
          fecha: "Octubre 2026",
          titulo: "Las Ligas ahora se llaman Circuitos",
          descripcion:
            "Lo que hasta ahora llamábamos Ligas, como Amon Sûl 2026, pasa a llamarse Circuitos: agrupan varios torneos en una clasificación conjunta. Están en el menú, en Circuitos, con los mismos torneos y clasificaciones de siempre. Así dejamos el nombre de Liga para un nuevo formato de torneo que llegará pronto.",
        },
        {
          fecha: "Octubre 2026",
          titulo: "Torneos de Dobles",
          descripcion:
            "Nuevo tipo de torneo: dos contra dos en la misma mesa, con un único resultado por partida que mete el capitán. El organizador elige si cada pareja entrega una lista por jugador o una lista conjunta. Las partidas cuentan para el ELO con 16 jugadores o más: se usa la media de ELO de cada pareja y los dos jugadores ganan o pierden lo mismo. Los antiguos torneos de Parejas, en los que cada miembro juega su propia partida, pasan a llamarse Equipos de 2.",
        },
        {
          fecha: "Octubre 2026",
          titulo: "ELO ganado y perdido en torneos",
          descripcion:
            "Las partidas de torneo del perfil muestran cuánto ELO se ganó o se perdió en cada una, en verde o en rojo junto al resultado. Se ha recuperado también el ELO de la mayoría de torneos ya jugados. Los torneos que no cuentan para el ELO, con 7 partidas o menos en la primera ronda, no lo muestran.",
        },
        {
          fecha: "Octubre 2026",
          titulo: "Nuevas tarjetas de partida",
          descripcion:
            "Las partidas de torneo y amistosas del perfil tienen un diseño más limpio: el resultado se muestra desde el punto de vista del jugador que estás viendo. Pulsando en el nick del rival vas a su perfil y, en partidas de torneo, pulsando en el ejército se abre la lista de ese jugador si el organizador ha hecho visibles las listas.",
        },
        {
          fecha: "Octubre 2026",
          titulo: "Resultados de torneos en el perfil",
          descripcion:
            "Nueva pestaña 'Resultados' en el detalle de cada jugador con todos los torneos que ha jugado y su posición final. Al pulsar un torneo se despliega su actuación: victorias, empates y derrotas, puntos a favor y en contra y el ejército utilizado. Pulsando en el número de partidas se abre el detalle de cada partida jugada en ese torneo.",
        },
        {
          fecha: "Agosto 2026",
          titulo: "Estadísticas de ejércitos",
          descripcion:
            "Nueva sección de estadísticas accesible desde el menú. Muestra el ranking de ejércitos por bando (Bien y Oscuridad) con los mejores y peores win rates, ocultando ejércitos con menos de 20 partidas. También permite consultar el rating detallado de cualquier ejército aplicando filtros por fechas, ejércitos o bando rival, y rango de puntos de partida.",
        },
        {
          fecha: "Agosto 2026",
          titulo: "Eliminar ronda",
          descripcion:
            "El administrador de un torneo puede eliminar la última ronda generada desde la pantalla de gestión. La operación borra todas las partidas de esa ronda y deja el torneo listo para volver a generar emparejamientos. Solo se puede eliminar la ronda más reciente.",
        },
        {
          fecha: "Agosto 2026",
          titulo: "Resumen de torneo",
          descripcion:
            "Nueva pestaña 'Resumen' en la vista de 'Resultados' en torneos. Muestra de un vistazo la fecha de inicio, el estado de cada ronda, si las listas y la clasificación son visibles, y el podio final. Carga de forma inmediata sin esperar al resto de datos. En torneos por equipos incluye podio individual y podio por equipos. Si las listas están disponibles, permite descargarlas en PDF directamente desde esta pantalla.",
        },
        {
          fecha: "Agosto 2026",
          titulo: "Contacto en torneos",
          descripcion:
            "Los organizadores ya pueden añadir un email o teléfono de contacto al crear un torneo. Si se rellena, será visible para los jugadores en el detalle del torneo.",
        },
        {
          fecha: "Agosto 2026",
          titulo: "Vista Home",
          descripcion:
            "Nueva pantalla de bienvenida con novedades y resumen de funcionalidades de la app.",
        },
      ],
      features: [
        {
          icon: gestionTorneos,
          title: "Gestión de eventos",
          description:
            "Crea y administra torneos individuales, de dobles o por equipos con emparejamientos automáticos, ligas de todos contra todos por jornadas y copas con fase de grupos y eliminatoria.",
        },
        {
          icon: ELO,
          title: "Sistema ELO",
          description:
            "Ranking competitivo que se actualiza tras cada torneo de 16 jugadores o más, y partida a partida en las ligas que cuentan para el ELO, para reflejar el nivel actual de cada jugador.",
        },
        {
          icon: clasificacion,
          title: "Clasificaciones",
          description:
            "Consulta la tabla de posiciones individual y por equipos de cada torneo.",
        },
        {
          icon: misPartidas,
          title: "Ficha de jugador",
          description:
            "Registra tus partidas amistosas, valida las pendientes y consulta tu historial, tu ELO y tus estadísticas.",
        },

        {
          icon: usuarios,
          title: "Comunidad",
          description:
            "Consulta el perfil de otros jugadores, sus ejércitos favoritos y su historial.",
        }
      ],
    };
  },
};
</script>

<style scoped>
/* El mismo dorado que los títulos de las mesas en el directo */
.novedad-titulo {
  color: #ffcc00;
}
.novedad-texto {
  text-align: justify;
  hyphens: auto;
}
</style>
